import React, { useEffect } from 'react';

import { DocumentNode, useQuery } from '@apollo/client';

import { Layer, TileCoords } from 'interfaces/maps.interface';
import { GET_VECTORS_FOR_BOUNDING_BOX } from 'GraphQL/queries/mapService';
import { isLocalEnv } from 'utils/constants';
import { useAppSelector } from 'store/hooks';
import useApolloClientAndMsalAuth from 'customHooks/useApolloClientAndMsalAuth';

type TileUnitProps = {
	coord: TileCoords;
	getVariables: (a: TileCoords, b: Layer, c: number) => any;
	height: any;
	onLoadCall: DocumentNode;
	onLoadCallCompleted: (a: any, b: Layer, c: TileCoords) => void;
	pruneTilesData: (a: string, b: Layer) => void;
	selectedLayer: Layer | null;
	width: any;
	zoom: number;
};

const TileUnit: React.FC<TileUnitProps> = ({
	coord,
	getVariables,
	height,
	onLoadCall = GET_VECTORS_FOR_BOUNDING_BOX,
	onLoadCallCompleted,
	pruneTilesData,
	selectedLayer,
	width,
	zoom,
}): JSX.Element => {
	const { client } = useApolloClientAndMsalAuth();
	const debugMode =
		`${useAppSelector(
			(s) => s.router.location.query.debug,
		)}`.toLowerCase() === 'true';

	useQuery(onLoadCall, {
		variables: getVariables(coord, selectedLayer!, zoom),
		client: client,
		skip: selectedLayer === null,
		fetchPolicy: 'network-only',
		onCompleted: (data) => {
			onLoadCallCompleted(data, selectedLayer!, coord);
		},
	});

	useEffect(() => {
		return () => {
			if (selectedLayer === null) return;
			pruneTilesData(`${coord.x}-${coord.y}`, selectedLayer);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div
			id={`${coord.x}-${coord.y}`}
			style={{
				width: width,
				height: height,
				color: isLocalEnv || debugMode ? 'white' : '#00000000',
				fontSize: '16px',
				fontWeight: 'bold',
				borderStyle: isLocalEnv || debugMode ? 'solid' : 'hidden',
				borderWidth: isLocalEnv || debugMode ? '0.5px' : '0px',
				borderColor: isLocalEnv || debugMode ? 'black' : '#00000000',
			}}
		>
			{String(coord)}
		</div>
	);
};

export default React.memo(TileUnit);
